import React, { useEffect } from 'react';
import { Close as CloseIcon } from 'pcln-icons';
import { Absolute } from '../Absolute/Absolute';
import { Flex } from '../Flex/Flex';
import { Relative } from '../Relative/Relative';
import { Text } from '../Text/Text';
import { LeftBorderFlex, RoundIconButton } from './Toast.styled';
/**
 * @public
 */
export function Toast({
  children,
  color = 'text.light',
  hideClose,
  icon,
  id,
  lifespan,
  variation = 'fill',
  onRemoveClick,
  ...props
}) {
  useEffect(() => {
    let timer;
    if (lifespan > 0) {
      timer = setTimeout(() => {
        onRemoveClick(id);
      }, lifespan);
    }
    return () => clearTimeout(timer);
  }, []);
  function handleRemoveClick() {
    onRemoveClick(id);
  }
  return React.createElement(Relative, null, React.createElement(LeftBorderFlex, {
    ...props,
    alignItems: 'center',
    borderRadius: 'lg',
    boxShadowSize: 'xl',
    color: color,
    justifyContent: 'space-between',
    variation: variation,
    p: 3,
    iconUsesColorScheme: !icon?.props.color
  }, icon && React.createElement(Flex, {
    mr: 3
  }, React.cloneElement(icon, {
    color: variation === 'border' && color
  })), React.createElement(Flex, {
    width: '100%'
  }, typeof children === 'string' ? React.createElement(Text, {
    textStyle: 'paragraph'
  }, children) : children)), !hideClose && React.createElement(Absolute, {
    top: -12,
    right: -12
  }, React.createElement(RoundIconButton, {
    borderRadius: 'full',
    boxShadowSize: 'sm',
    icon: React.createElement(CloseIcon, {
      color: 'primary',
      size: 20,
      title: 'close-toast'
    }),
    onClick: handleRemoveClick
  })));
}